import Modal from "../../../../shared/Modal";
import Select from "../../../../shared/Select";
import Input from "../../../../shared/Input";
import { accessoryOptions } from "../../../../constants/select";
import { parseFixed } from "../../../../utils";
import Button from "../../../../shared/Button";
import React from "react";

const AddAccModal = ({
  form,
  visible,
  setVisible,
  submit,
  loading,
  cancel,
  appType,
}) => {
  function handleCancelModal() {
    cancel && cancel();
    setVisible(false);
    form.clearForm();
  }

  const isEdit = Boolean(form?.form?.edit);
  const isTrucking = appType === "trucking";

  const CUSTOM_ACCESSORY_VALUE = "__CUSTOM_ACCESSORY__";
  const accessoryOptionsWithCustom = React.useMemo(() => {
    return [
      {
        id: "custom_accessory",
        label: "Custom…",
        value: CUSTOM_ACCESSORY_VALUE,
        body: (
          <div className="flex items-center justify-between">
            <div className="text-gray-500">Custom…</div>
            <div className="text-xs text-gray-400">type your own</div>
          </div>
        ),
      },
      ...(accessoryOptions || []),
    ];
  }, []);

  const isPresetAccessoryType = React.useMemo(() => {
    const currentType = form?.form?.type;
    if (!currentType) return false;
    return (accessoryOptions || []).some((o) => o?.value === currentType);
  }, [form?.form?.type]);

  const isCustomAccessoryType = isTrucking && Boolean(form?.form?.type) && !isPresetAccessoryType;

  function handleAccessoryTypeChange(e: any) {
    // When selecting from the dropdown, keep `form.form.type` as the actual
    // value we want to save (backwards compatible with existing API payload).
    if (e?.value === CUSTOM_ACCESSORY_VALUE) {
      // Switch to "custom input" mode by clearing preset selection
      form.setFormInit({ typeSelectLabel: "Custom…" });
      // If we were on a preset, clear it so user is prompted to type
      if (isPresetAccessoryType) {
        form.setFormInit({ type: "" });
      }
      return;
    }

    // Preset option selected
    form.setFormInit({ typeSelectLabel: "" });
    form.updateForm({ id: "type", value: e?.value });
  }

  const modalFooter = (
    <>
      <Button onClick={handleCancelModal} type="alternative">
        Cancel
      </Button>
      <Button
        loading={loading}
        disabled={loading}
        onClick={submit}
        type="primary"
      >
        {isEdit ? "Save" : "Submit"}
      </Button>
    </>
  );

  const modalContent = (
    <div className="grid gap-3 sm:grid-cols-2">
      <div className="w-full sm:col-span-2">
        {appType === "trucking" && (
          <>
            <Select
              options={accessoryOptionsWithCustom}
              onChange={handleAccessoryTypeChange}
              id="type"
              value={
                form?.form?.typeSelectLabel ||
                (isCustomAccessoryType ? "Custom…" : form?.form?.type)
              }
              size="md"
              placeholder="Accessory Type"
              label="Accessory"
              // wrapperClasses="w-full"
            />
            {(form?.form?.typeSelectLabel || isCustomAccessoryType) && (
              <div className="mt-3">
                <Input
                  onChange={form.updateForm}
                  value={form?.form?.type}
                  id="type"
                  size="md"
                  placeholder="Custom accessory name"
                  label="Custom Accessory"
                />
              </div>
            )}
          </>
        )}
        {appType === "serviceRepair" && (
          <Input
            onChange={form.updateForm}
            value={form.form.type}
            id="type"
            size="md"
            placeholder="Accessory Name"
            label="Accessory"
          />
        )}
      </div>
      <div className="w-full">
        <Input
          onChange={form.updateForm}
          value={form.form.quantity}
          id="quantity"
          size="md"
          type="number"
          min={0}
          placeholder="Quantity"
          label="Quantity"
          // wrapperClasses="w-full"
        />
      </div>
      <div className="w-full">
        <Input
          value={form.form.unitPrice}
          id="unitPrice"
          size="md"
          type="number"
          min={0}
          placeholder="Unit Price"
          label="Unit Price"
          // wrapperClasses="w-full"
          step="0.05"
          onChange={(target) => {
            const value = typeof target === "string" ? target : target?.value;
            form.updateForm({
              id: "unitPrice",
              value: parseFixed(value),
            });
          }}
          icon={{
            left: <div className="text-gray-500 text-sm">$</div>,
          }}
        />
      </div>
    </div>
  );

  return (
    <Modal
      visible={visible}
      setVisible={setVisible}
      onClose={() => setVisible(false)}
      title={isEdit ? "Edit Accessory" : "Add Accessory"}
      footer={modalFooter}
      content={modalContent}
      size="md"
      footerPosition="right"
    />
  );
};

export default AddAccModal;
